import { render } from "./BaseQRCodeViewer.vue?vue&type=template&id=7c91f543&ts=true"
import script from "./BaseQRCodeViewer.vue?vue&type=script&lang=ts"
export * from "./BaseQRCodeViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__